import { render, staticRenderFns } from "./ProjectImage.vue?vue&type=template&id=0af19264&scoped=true&"
import script from "./ProjectImage.vue?vue&type=script&lang=js&"
export * from "./ProjectImage.vue?vue&type=script&lang=js&"
import style0 from "./ProjectImage.vue?vue&type=style&index=0&id=0af19264&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af19264",
  null
  
)

export default component.exports